export default __webpack_public_path__ + "static/media/Armbands of Vernant Fury.9cb2a239.jpg";